import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';
import { Router } from '@angular/router';
import { AuthandregistryService } from './authandregistry.service';
import { UserdataService } from './userdata.service';

@Injectable({
    providedIn: 'root'
})
export class DeletionService {
    data = new BehaviorSubject<any>(null);

    constructor(
        private http: HttpClient,
        private snack: SnackService,
        private router: Router,
        private authService: AuthandregistryService,
        private userdata: UserdataService
    ) { }

    async deleteUser(): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.delete(serverurl + '/deletion/user').subscribe({
                next: (data: any) => {
                    this.snack.success(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });

    }

    async deleteCompany(deleteMembers: boolean): Promise<boolean> {
        let memberHandlingType: string;
        if(deleteMembers) {
            memberHandlingType = 'DELETE'
        } else {
            memberHandlingType = 'UPDATE'
        }
        return await new Promise((resolve) => {
            this.http.delete(serverurl + '/deletion/company/' + memberHandlingType).subscribe({
                next: (data: any) => {
                    console.log("COMPANY DELETION", data)
                    this.snack.success(data);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async confirm(confirmId: string): Promise<boolean | number> {
        return await new Promise((resolve) => {        
            this.http.delete(`${serverurl}/deletion/confirm/${confirmId}`)
                .subscribe({
                    next: (data: any) => {
                        console.log(data)
                        this.snack.success(data);
                        if(data.confirmData.entityType == 'COMPANY_DELETE' || data.confirmData.entityType == 'COMPANY_UPDATE') {
                            if(data.userdata) {
                                this.userdata.updateUserData(data.userdata);
                            }
                            this.router.navigate(['/home', 'user']);
                        } else if(data.confirmData.entityType == 'USER') {
                            this.router.navigate(['/login']);
                        } 
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.snack.error(err);
                        resolve(err.status);
                    }
                });
        
        })
    }

    async reject(confirmId: string): Promise<boolean | number> {
        return await new Promise((resolve) => {        
            this.http.post(`${serverurl}/deletion/reject/${confirmId}`, { confirmId: confirmId })
                .subscribe({
                    next: (data: any) => {
                        this.snack.success(data);
                        this.router.navigate(['/home', 'user']);
                        resolve(true);
                    },
                    error: (err: HttpErrorResponse) => {
                        this.snack.error(err);
                        resolve(err.status);
                    }
                });
        
        })
    }
}
